<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{title}}</a>
      </div>
      <div class="collapse navbar-collapse">
        <!-- <form class="navbar-form navbar-left navbar-search-form" role="search">
          <div class="input-group">
            <input type="text" value="" class="form-control" placeholder="Search...">
            <span class="input-group-addon"><i class="fa fa-search"></i></span>
          </div>
        </form> -->
        <ul class="nav navbar-nav navbar-right">
          <li class="open">
            <router-link :to="{name: 'Overview'}" class="dropdown-toggle btn-magnify" data-toggle="dropdown">
              <i class="ti-panel"></i>
              <p>Tableau de bord</p>
            </router-link>
          </li>
          <drop-down tag="li" title="5" icon="ti-bell">
            <li><a href="#">Notification 1</a></li>
            <li><a href="#">Notification 2</a></li>
            <li><a href="#">Notification 3</a></li>
            <li><a href="#">Notification 4</a></li>
            <li><a href="#">Another notification</a></li>
          </drop-down>
          <li>
            <router-link :to="{name: 'ProfileSettings'}" class="btn-rotate">
              <i class="ti-settings"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    },
    computed: {
      title () {
        // temporary solution
        switch (this.$route.name) {
          case 'StoreView':
            return 'Boutique'
          case 'StoreAdd':
            return `Ajout d'une boutique`
          case 'StoreList':
            return 'Vos boutiques'
          case 'Overview':
            return 'Tableau de bord'
          case 'ProfileEdit':
            return 'Mise à jour du profil'
          case 'ProfileSettings':
            return 'Paramètres'
          case 'ProductList':
            return 'Produits'
          case 'ProductAdd':
            return `Ajout d'un produit`
          case 'Settings':
            return 'Paramètres'
          case 'Dashboard':
            return 'Tableau de bord'
          case 'OrderList':
            return 'Commandes'
          default:
            return this.$route.name
        }
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue